module.exports = __webpack_public_path__ + "static/img/manager_firma_rocael.299fde7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/manager_firma_rocael.png
// module id = 9cIR
// module chunks = 1